@if (src) {
  @switch (type) {
    @case ('pdf') {
      <ng2-pdfjs-viewer [pdfSrc]="getPdfSrc()" [locale]="locale" />
    }
    @case ('img') {
      <img [src]="src | safeUrl" />
    }
    @default {
      <h3>{{ 'embed.noPreview' | translate: { ext: extension } }}</h3>
    }
  }
}
